import { Typography, Grid, SxProps } from "@mui/material";
import React from "react";

export interface LabelItemProps {
    title: string
    titleSx?: SxProps
    children: React.ReactNode
}

const LabelItem: React.FC<LabelItemProps> = ({
    title,
    titleSx,
    children
}) => {
    return (
        <Grid container>
            <Grid item xs={12} sm={6} md={4} sx={{ ...titleSx }}>
                <Typography variant="caption" sx={{color: "#333399"}}>{title}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>{children}</Grid>
        </Grid>
    );
}

export default LabelItem